import SparkMD5 from "spark-md5"
import { message } from "antd"
import { uploadChunk } from "./uploadChunks"
const blobSlice = File.prototype.slice || File.prototype.mozSlice || File.prototype.webkitSlice
const hashChunkSize = 4194304 // 4M
const uploadChunkSize = 4194304 // 4M
import stores from "../stores"

const cutFile = (file, fn) => {
  return new Promise((resolve, reject) => {
    let chunkCount = Math.ceil(file.size / hashChunkSize)
    let currentChunk = 0
    let fileReader = new FileReader()

    fileReader.onload = function (e) {
      fn(e)
      currentChunk++

      if (currentChunk < chunkCount) {
        loadNext()
      } else {
        resolve()
      }
    }

    fileReader.onerror = () => {
      reject(new Error('文件读取错误'))
    }

    function loadNext() {
      let start = currentChunk * hashChunkSize
      let end = ((start + hashChunkSize) >= file.size) ? file.size : start + hashChunkSize
      fileReader.readAsArrayBuffer(blobSlice.call(file, start, end))
    }

    loadNext()
  })
}

export const getFileHash = (file) => {
  let spark = new SparkMD5.ArrayBuffer()
  return cutFile(file, e => {
    spark.append(e.target.result)
  }).then(() => {
    return Promise.resolve(spark.end())
  })
}

/**
 * get hash array of chunks
 */
export const getFileHashes = (file) => {
  let res = []
  return cutFile(file, e => {
    res.push(SparkMD5.ArrayBuffer.hash(e.target.result))
  }).then(() => {
    return Promise.resolve(res)
  })
}

export const startTask = (file, index, onProgress) => {
  return new Promise((resolve, reject) => {
    let chunkCount = getChunkCount(file.size)
    let currentChunk = 0
    let fileReader = new FileReader()

    fileReader.onload = event => { // 文件读取的回调
      uploadChunk(
        event.target.result,
        currentChunk,
        () => {
          if (currentChunk + 1 < chunkCount) { // 下一片的下标是否在范围内
            currentChunk++
            loadNextChunk()
          } else {
            resolve(chunkCount)
          }
        },
        progress => {
          if (progress.isNormal) {
            const progressForFile = (progress.value + currentChunk * 100 ) / chunkCount
            progress.value = progressForFile >= 98 ? 98 : progressForFile
          }
          onProgress(progress)
        }
      )
    }

    fileReader.onerror = error => { // uploadChunk 的异常都已被处理，不会抛到上层
      reject(error)
    }

    function loadNextChunk() { // 从指定 start --> end 读文件
      let start = currentChunk * uploadChunkSize
      let end = ((start + uploadChunkSize) >= file.size) ? file.size : start + uploadChunkSize
      fileReader.readAsArrayBuffer(blobSlice.call(file, start, end))
    }

    loadNextChunk()
  })
}

export function getChunkCount (fileSize) {
  return Math.ceil(fileSize / uploadChunkSize)
}

// 向下取整
export function fixProgress (progress) {
  return Math.floor(progress)
}

/**
 * Upload 模块的上传重试机制
 * 5s 一次，连续 20 次宣告失败, 共计 500s，8.3mins
 * 不论成功、失败都需要重置计时器
 * times === 20 reject,否则正常
 */
let times = 0
export function reTry (action, text = "您当前网络不稳定，正在重试连接！") {
  return new Promise((resolve, reject) => {
    message.error(text)
    if (times < 20) {
      const duration = 5000 + 2000 * times++
      stores.manager.currentTask.countDown(duration / 1000, action)
    } else {
      resetTimes()
      reject()
    }
  })
}

export function resetTimes () {
  times = 0
}



// WEBPACK FOOTER //
// ./src/app/components/normal/BasicModal/UploadModal/tools/uploadTools.js